export const GENERAL_CONFIG = 'general-config';
export const METADATA_CONFIG = 'metadata-config';
export const PREPROCESSOR_CONFIG = 'preprocessor-config';
export const LLM_CONFIG = 'llm-params';
export const RANKER_CONFIG = 'ranker-config';
export const PROMPT_CONFIG = 'prompt-config';
export const EMBEDDING_CONFIG = 'embedding-config';
export const DATA_CONFIG = 'data-config';
export const SEARCH_RESULT_CONFIG = 'search-result-config';
